import React from 'react';
import * as fn from '../../../utilities/_functions';

import './DisabledOverlay.scss';

function DisabledOverlay(props) {
    return <div className={'disabled-overlay' + (props.isLoading ? '' : ' d-none')} style={{ zIndex: fn.getHighestZIndex() + 1 }}></div>
}

export default DisabledOverlay;